import {
  Collapse,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useState } from "react";
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";

const NavItem = (props) => {
  const { icon, path, title, child = [] } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const handlePage = (url) => {
    navigate(url);
  };
  const sxActive = {
    backgroundColor: "var(--primaryTSM-color)",
    "& .MuiListItemIcon-root": {
      color: "var(--darkGreen-color) !important",
    },
    "& .MuiTypography-root": {
      color: "var(--darkGreen-color)",
      fontWeight: "500",
    },
  };
  return (
    <Grid className={`${open && "bg-deepWhite"} br-6 mb-10`}>
      {child.length > 0 ? (
        <>
          <ListItemButton
            onClick={() => setOpen(!open)}
            sx={open ? sxActive : {}}
          >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={title} />
            {/* Child Menu */}
            {open ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
          </ListItemButton>
          <Collapse in={open}>
            <List className="p-0">
              {child.map((item, i) => (
                <ListItemButton
                  key={i}
                  onClick={() => handlePage(item.path)}
                  component={NavLink}
                  to={item.path}
                  sx={{
                    mt: 1,
                    pl: 4,
                    "&.active": sxActive,
                  }}
                >
                  <ListItemIcon>
                    <ArrowRightAltRoundedIcon />
                  </ListItemIcon>
                  <ListItemText primary={item.title} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        </>
      ) : (
        <ListItemButton
          onClick={() => handlePage(path)}
          component={NavLink}
          to={path}
          sx={{
            "&.active": sxActive,
          }}
        >
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={title} />
        </ListItemButton>
      )}
    </Grid>
  );
};

export default NavItem;
